/* eslint-disable */

require('jquery-validation');
require('jquery-validation/dist/additional-methods');       // Extra validation types

var $                       = require('jquery');
var validateHelpers         = require('./form-validation-helper');
var mailcheck               = require('./form-validation-mailcheck');


// Define jQuery Selectors
var FORM_FIELD              = '.form__field';              // Field container
var VALIDATION_MESSAGE      = '.form__error';              // Container holding form field

                                                           // Define Classes
var INPUT_VALID             = 'form__field--valid';        // Input is valid
var INPUT_INVALID           = 'form__field--invalid';      // Input is invalid
var FIELD_CREDIT_CARD       = 'input__field--creditCard';  // Class for Credit Card inputs

var VALIDATION_ICON_VALID   = 'validation__icon--valid';   // Validation valid icon
var VALIDATION_ICON_INVALID = 'validation__icon--invalid'; // Validation invalid icon



module.exports = function() { /* Nothing to Export */ };



$(document).ready(function() {

    // Init Validation Modules
    mailcheck();

    // Clear field when the "invalid icon" is clicked (generally an "X")
    $('.'+VALIDATION_ICON_INVALID).on('click', function() {
        // Clear text-based inputs
        $(this).parents(FORM_FIELD).find('\
            input[type=text], \
            input[type=color], \
            input[type=date], \
            input[type=datetime-local], \
            input[type=email], \
            input[type=file], \
            input[type=month], \
            input[type=number], \
            input[type=password], \
            input[type=search], \
            input[type=tel], \
            input[type=time], \
            input[type=url], \
            input[type=week], \
            textarea \
        ').val('');

        // Clear radio/checkboxes
        $(this).parents(FORM_FIELD).find('\
            input[type=checkbox], \
            input[type=radio] \
        ').attr('checked', false);
    });

    // ------------------------------------
    // jQuery Validation Library
    // Default Configuration
    // ------------------------------------
    $.validator.setDefaults({
        // Enable debug mode to debug (WARNING: if it's set to true, you CANNOT submit forms!)
        // debug: true,

        // This class is added to an element after it was validated and considered valid.
        validClass: INPUT_VALID,

        // Use this class to create error labels, to look for existing error labels and to add it to invalid elements.
        errorClass: INPUT_INVALID,

        // Wrapper element for the error messages output by the plugin. By default the wrapper is a label, which is dumb.
        errorElement: 'span',

        // How to highlight invalid fields. Override to decide which fields and how to highlight.
        highlight: function(element, errorClass, validClass) {
            // Add 'invalid' class
            $(element).closest(FORM_FIELD).removeClass(validClass).addClass(errorClass);

            // Highlight credit card type (if relevant)
            if ($(element).hasClass(FIELD_CREDIT_CARD)) {
                validateHelpers.highlightCreditCardType(element);
            }
        },

        // Called to revert changes made by option highlight, same arguments as highlight.
        unhighlight: function(element, errorClass, validClass) {
            // Add 'valid' class
            $(element).closest(FORM_FIELD).removeClass(errorClass).addClass(validClass);

            // Highlight credit card type (if relevant)
            if ($(element).hasClass(FIELD_CREDIT_CARD)) validateHelpers.highlightCreditCardType(element);
        },

        // Place the error message
        errorPlacement: function (error, element) {
            // A <small> tag with class .form__validation is added to the markup by formkit macro.
            // Add the error message to that container.
            var messageContainer = element.closest(FORM_FIELD).find(VALIDATION_MESSAGE);
            error.appendTo(messageContainer);

            // var isCheckOrRadio = element.is(':checkbox') || element.is(':radio');
            // if (isCheckOrRadio) { error.prependTo(parentField); }
            // else { error.appendTo(parentField); }
        },

        // Validate function on focus out
        // - By default tabbing through fields won't run validation unless it was previously marked as invalid
        // - We want to validate as they tab through fields (i.e. immediate feedback when 'skipping fields')
        onfocusout: function(element) {
            $(element).valid();
        }

    });


    // ----------------------------------
    // Custom Validation Methods
    // ----------------------------------

    /*
     * Enhance "Email" validation to require "x@x.x" instead of just "x@x"
     * Source: https://stackoverflow.com/questions/2855865/validating-email-addresses-using-jquery-and-regex/2855946#2855946
     * Author: Luca Filosofi (https://lucafilosofi.com)
     */
    $.validator.methods.email = function( value, element ) {
        return this.optional( element ) || /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i.test( value );
    };

    $.validator.methods.blockExampleEmail = function( value, element ) {
        if( value.indexOf("@example.") >= 0 ){
            return false;
        }else{
            return true;
        }
    };


    /*
     * Postal Code Validation
     * Modified from the provided 'additional-methods' to support:
     * - Case insensitive
     * - Optional space or dash
     */
    $.validator.addMethod('postalCodeCA', function( value, element ) {
        return this.optional( element ) || /^[ABCEGHJKLMNPRSTVXY]\d[A-Z][ -]?\d[A-Z]\d$/.test( value.toUpperCase() );
    }, 'Please specify a valid postal code (e.g. A1A 1A1)' );


    /*
     * Zip/Postal Code Validation
     * - Either a valid 'postalCodeCA' or 'zipcodeUS'
     */
    $.validator.addMethod('zipPostal', function( value, element ) {
        return this.optional( element ) || $.validator.methods.postalCodeCA.apply(this, arguments) || $.validator.methods.zipcodeUS.apply(this, arguments);
    }, 'Please specify a valid zip or postal code' );


    /*
     * Credit Card Expiry Date Validation
     * - MM/YY with months between 01-12 and years from 00-99
     */
    $.validator.addMethod('creditCardExpiry', function( value, element ) {
        return this.optional( element ) || /^(0[1-9]|1[012])\/\d{2}$/.test(value);
    }, 'Please enter a valid expiry date (e.g. 01/22)' );


    /*
     * No PO Box Validation
     * - Case insensitive
     */
    $.validator.addMethod('noPOBox', function( value, element ) {
        return this.optional(element) || ! /(P(OST)?\.?\s*O(FF(ICE)?)?\.?\s*((BOX)|(BIN)))|(^[^0-9]*((P(OST)?\.?\s*O(FF(ICE)?)?\.?)|((BOX)|(BIN))))/i.test(value);
    }, 'Please note: we do not ship to P.O. Boxes' );


    /*
     * Customize default creditcardtypes validation
     * Ignore all whitespace
     */
    $.validator.addMethod('creditcardtypesCustom', function(value, element, param) {

        value = value.replace(/\D/g, '');

        var validTypes = 0x0000;

        if (param.mastercard) {
            validTypes |= 0x0001;
        }
        if (param.visa) {
            validTypes |= 0x0002;
        }
        if (param.amex) {
            validTypes |= 0x0004;
        }
        if (param.dinersclub) {
            validTypes |= 0x0008;
        }
        if (param.enroute) {
            validTypes |= 0x0010;
        }
        if (param.discover) {
            validTypes |= 0x0020;
        }
        if (param.jcb) {
            validTypes |= 0x0040;
        }
        if (param.unknown) {
            validTypes |= 0x0080;
        }
        if (param.all) {
            validTypes = 0x0001 | 0x0002 | 0x0004 | 0x0008 | 0x0010 | 0x0020 | 0x0040 | 0x0080;
        }
        if (validTypes & 0x0001 && /^(5[12345])/.test(value)) {          // mastercard
            return value.length === 16;
        }
        if (validTypes & 0x0002 && /^(4)/.test(value)) {                 // visa
            return value.length === 16;
        }
        if (validTypes & 0x0004 && /^(3[47])/.test(value)) {             // amex
            return value.length === 15;
        }
        if (validTypes & 0x0008 && /^(3(0[012345]|[68]))/.test(value)) { // dinersclub
            return value.length === 14;
        }
        if (validTypes & 0x0010 && /^(2(014|149))/.test(value)) {        // enroute
            return value.length === 15;
        }
        if (validTypes & 0x0020 && /^(6011)/.test(value)) {              // discover
            return value.length === 16;
        }
        if (validTypes & 0x0040 && /^(3)/.test(value)) {                 // jcb
            return value.length === 16;
        }
        if (validTypes & 0x0040 && /^(2131|1800)/.test(value)) {         // jcb
            return value.length === 15;
        }
        if (validTypes & 0x0080) {                                       // unknown
            return true;
        }

        return false;
    }, 'Please enter a valid credit card number.');

});
